var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileM({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87023 10H23.1202C24.3702 10 25.0002 10.59 25.0002 11.79V20.21C25.0002 21.4 24.3702 22 23.1202 22H9.87023C8.62023 22 7.99023 21.4 7.99023 20.21V11.79C7.99023 10.59 8.62023 10 9.87023 10ZM16.4902 18.6L23.2302 13.07C23.4702 12.87 23.6602 12.41 23.3602 12C23.0702 11.59 22.5402 11.58 22.1902 11.83L16.4902 15.69L10.8002 11.83C10.4502 11.58 9.92023 11.59 9.63023 12C9.33023 12.41 9.52023 12.87 9.76023 13.07L16.4902 18.6Z",
    fill: "#395E9D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#395E9D",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileM);
export default __webpack_public_path__ + "static/media/profileM.4369f01bde9012041ac03162cd479954.svg";
export { ForwardRef as ReactComponent };